var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app flex-row align-items-center" },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-card-group",
                    [
                      _c(
                        "b-card",
                        { staticClass: "p-4", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("h1", [_vm._v(_vm._s(_vm.$t("login_title")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.$t("login_description")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.error != null,
                                      expression: "error != null"
                                    }
                                  ],
                                  staticClass: "text-danger"
                                },
                                [_vm._v(_vm._s(_vm.error))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }, [
                                _c("br")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.login($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("i", {
                                                staticClass: "icon-user"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t("username"),
                                          "aria-describedby":
                                            "username-feedback"
                                        },
                                        model: {
                                          value: _vm.body.username,
                                          callback: function($$v) {
                                            _vm.$set(_vm.body, "username", $$v)
                                          },
                                          expression: "body.username"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group",
                                    { staticClass: "mb-4" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("i", {
                                                staticClass: "icon-lock"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "password",
                                          placeholder: _vm.$t("password"),
                                          "aria-describedby":
                                            "password-feedback"
                                        },
                                        model: {
                                          value: _vm.body.password,
                                          callback: function($$v) {
                                            _vm.$set(_vm.body, "password", $$v)
                                          },
                                          expression: "body.password"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "5" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "px-4",
                                              attrs: { variant: "primary" },
                                              on: { click: _vm.login }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("login_title"))
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right",
                                          attrs: { cols: "7" }
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "px-0",
                                              attrs: { variant: "link" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("forgot_password")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass:
                            "text-white bg-primary py-5 d-md-down-none",
                          staticStyle: { width: "44%" },
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "text-center login-card-body" },
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "login-language" },
                                  [_c("change-language")],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "login-logo",
                                  attrs: {
                                    src: "static/img/logo.png",
                                    alt: "Central Hub"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticStyle: { display: "none" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("slogan")) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", { staticClass: "login-copyright" }, [
                                  _vm._v("copyright © 2018")
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b46c3df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b46c3df","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Login.vue
// module id = 1333
// module chunks = 0